module.exports = __webpack_public_path__ + "img/ppp.45f7ceb6.svg";